function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 24.37c-6.63 0-12-5.37-12-12s5.37-12 12-12 12 5.37 12 12-5.37 12-12 12zm5.39-13.48c.24-1.57-.96-2.42-2.6-2.98l.53-2.13-1.3-.32-.52 2.07c-.34-.09-.69-.16-1.04-.24l.52-2.09-1.3-.32L11.17 7c-.28-.07-.56-.13-.83-.2v-.01l-1.79-.45-.35 1.39s.96.22.94.23c.53.13.62.48.6.75l-.6 2.43c.04.01.08.02.14.04l-.14-.03-.85 3.4c-.06.16-.23.4-.6.31.01.02-.94-.24-.94-.24l-.64 1.48 1.69.42c.31.08.62.16.92.24l-.54 2.15 1.3.32.53-2.13c.35.1.7.18 1.03.27l-.53 2.12 1.3.32.54-2.15c2.21.42 3.87.25 4.57-1.75.56-1.61-.03-2.54-1.19-3.14.85-.17 1.49-.73 1.66-1.88zm-2.96 4.15c-.4 1.61-3.11.74-3.99.52l.71-2.85c.88.22 3.7.65 3.28 2.33zm.4-4.17c-.37 1.46-2.62.72-3.35.54l.65-2.59c.72.18 3.08.52 2.7 2.05z",
  fill: "#F7931A"
});

function SvgBtc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "32dd77fd7542fa251e497e61b5fba3f0.svg";
export { SvgBtc as ReactComponent };